export const EmailRegex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
export const PhoneNumberRegex = /^(\\+98|0)?9\\d{9}?$/;
export const PhoneNumberRegex2 = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
export const IpRegex = /^(([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\\.){3}([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])$/;
export const uriRegex = /^\/(?!\/)([a-zA-Z0-9-_]*(\/(?!\/))?)*$/;
export const LettersAndNumbersOnly = /^[a-zA-Z0-9]*$/;

export const EnglishAlphabetRegex = /^[a-zA-Z0-9 ]*$/;
export const PostalCodeRegex = /^[0-9]{10}$/;
export const CountryCodeRegex = /^(?!0098|[+]*98)(\\+?\\d{1,3}|\\d{1,4})$/;
export const Exclude98phoneNumberRegex = /^(?!0098|\\+98)/;

export const ContainLowercaseRegex = /[a-z]/;
export const ContainUppercaseRegex = /[A-Z]/;
export const ContainNumberRegex = /\\d/;
export const ContainSpecialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
export const NotContainPersianChar = /^[^<\u0600-\u06FF>]+$/;
export const ContainPersianChar = /[\u0600-\u06FF]/;
export const OnlyNumber = /^[0-9]*$/;
export const DateRegex = /^\d{4}-\d{2}-\d{2}$/;
export const OnlyAlphabeticRegex = /^[A-Za-z\s]+$/;
export const BSBRegex = /^\d{6}$/;
export const ShebaRegex = /^\d{24}$/;
export const SwiftCodeRegex = /^[A-Z]{6}[A-Z2-9]{2}([A-Z2-9]{3})?$/;
export const EnglishOnlyPattern = /^[A-Za-z0-9!@#$%^&*()\-_=+{}\[\]:;\"'<>,.?/\\|`~\s]*$/;
